export const ICONS_MAP = [
    {
        origins: ['t.me', 'telegram.org'],
        iconMapped: { icon: 'TelegramIcon' },
    },
    {
        origins: ['vk.com'],
        iconMapped: { icon: 'VKIcon' },
    },
    {
        origins: ['ok.ru'],
        iconMapped: { icon: 'OkIcon' },
    },
    {
        origins: ['apps.apple.com'],
        iconMapped: { icon: 'AppleIcon' },
    },
    {
        origins: ['play.google.com'],
        iconMapped: { icon: 'PlayMarketIcon' },
    },
    {
        origins: ['appgallery.huawei.com'],
        iconMapped: { icon: 'HuaweiIcon' },
    },
    {
        origins: ['youtube.com'],
        iconMapped: { icon: 'YoutubeIcon' },
    },
    {
        origins: ['rutube.ru'],
        iconMapped: { icon: 'RutubeIcon' },
    },
    {
        origins: ['dzen.ru'],
        iconMapped: { icon: 'DzenIcon' },
    },
    {
        origins: ['rustore.ru'],
        iconMapped: { icon: 'RustoreIcon' },
    },
];
//# sourceMappingURL=iconsMap.js.map